import { render, staticRenderFns } from "./salestable.vue?vue&type=template&id=2b49963f&"
import script from "./salestable.vue?vue&type=script&lang=js&"
export * from "./salestable.vue?vue&type=script&lang=js&"
import style0 from "./salestable.vue?vue&type=style&index=0&id=2b49963f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports